import { render, staticRenderFns } from "./configWxPush.vue?vue&type=template&id=d2ded492&"
import script from "./configWxPush.vue?vue&type=script&lang=js&"
export * from "./configWxPush.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports